import { createSelector } from 'reselect'

const getMediaFile = (state) => state.media.file
const getMediaFolder = (state) => state.media.folder
const getMediaLoading = (state) => state.media.loading

export const fileSelector = createSelector(getMediaFile, (file) => file)

export const folderSelector = createSelector(getMediaFolder, (folder) => folder)

export const loadingSelector = createSelector(
  getMediaLoading,
  (loading) => loading,
)
